module.exports = __webpack_public_path__ + "site/img/function1.33972e6.png";


//////////////////
// WEBPACK FOOTER
// ./site/function1.png
// module id = 97
// module chunks = 1